module.exports = __webpack_public_path__ + "static/media/home.bb677cb2.png";